import { render, staticRenderFns } from "./request-list.vue?vue&type=template&id=15c4fae0&scoped=true"
import script from "./request-list.vue?vue&type=script&lang=js"
export * from "./request-list.vue?vue&type=script&lang=js"
import style0 from "./request-list.vue?vue&type=style&index=0&id=15c4fae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c4fae0",
  null
  
)

export default component.exports